module.exports = __webpack_public_path__ + "img/frame (109).900b7c90.jpg";